import { render, staticRenderFns } from "./PageReview.vue?vue&type=template&id=368b1f94&scoped=true"
import script from "./PageReview.vue?vue&type=script&lang=js"
export * from "./PageReview.vue?vue&type=script&lang=js"
import style0 from "./PageReview.vue?vue&type=style&index=0&id=368b1f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b1f94",
  null
  
)

export default component.exports